module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/banner/en-3b7cd0ad4ee975d72add96366907cb1b.jpg";